import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { getAnswerFromLabel } from 'affiny-core/modules/helpers/informationList';
import { TAnswersLabels } from 'affiny-core/modules/memberchoices/types';

export const selectTastes = (memberAnswerLabels: TAnswersLabels) => ({
  musics: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestMusicStyle
  ),
  movies: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestFilm
  ),
  leisures: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileLeisure
  ),
  holidays: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.selftestHolidayDestination
  ),
});

export type ITastes = ReturnType<typeof selectTastes>;
